import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d8decbe"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "account-select"
}
const _hoisted_2 = { class: "account-select__list" }
const _hoisted_3 = { class: "account-select__link top-inset" }
const _hoisted_4 = {
  key: 1,
  class: "account-select"
}

import { Account } from "@/types/account";
import { PropType, ref } from "vue";
import ExpandSmall from "@/icons/common/expand-small.vue";
import AccountSelectItem from "./components/account-select-item.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  account: {
    type: Object as PropType<Account>,
    default: null,
  },
  accounts: {
    type: Object as PropType<Array<Account>>,
    default: () => {
      return [];
    },
  },
  recent: {
    type: Object as PropType<Array<Account>>,
    default: () => {
      return [];
    },
  },
},
  emits: ["update:selectAccount"],
  setup(__props, { emit }) {

const props = __props;





const isOpen = ref<boolean>(props.recent.length === 0);

const selectAccount = (account: Account) => {
  emit("update:selectAccount", account);
};

const toggle = () => {
  isOpen.value = !isOpen.value;
};

return (_ctx: any,_cache: any) => {
  return (__props.recent !== null)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("a", {
          class: "account-select__link",
          onClick: toggle
        }, [
          _createTextVNode(" My accounts"),
          _createVNode(ExpandSmall, {
            class: _normalizeClass({ open: isOpen.value })
          }, null, 8, ["class"])
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.accounts, (item, index) => {
            return (_openBlock(), _createBlock(AccountSelectItem, {
              key: index,
              account: item,
              onClick: ($event: any) => (selectAccount(item))
            }, null, 8, ["account", "onClick"]))
          }), 128))
        ], 512), [
          [_vShow, isOpen.value]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_3, " Recent ", 512), [
          [_vShow, __props.recent.length > 0]
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.recent, (item, index) => {
          return (_openBlock(), _createBlock(AccountSelectItem, {
            key: index,
            account: item,
            onClick: ($event: any) => (selectAccount(item))
          }, null, 8, ["account", "onClick"]))
        }), 128))
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.accounts, (item, index) => {
          return (_openBlock(), _createBlock(AccountSelectItem, {
            key: index,
            account: item,
            onClick: ($event: any) => (selectAccount(item))
          }, null, 8, ["account", "onClick"]))
        }), 128))
      ]))
}
}

})